<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="container content-wrap">
      <div class="row">
        <section>
          <div class="offers">
            <div class="item-info-card-header">
              <img
                src="/static/images/pngs/radio.png"
                alt="Operator"
                class="item-info-card-header__image"
              />
              <div class="item-info-card-header__text">
                <p class="item-info-card-header__text__title">July 1 - Present</p>
              </div>
            </div>
            <StatementItem v-for="(item,index) in filteredStatement" :key="index" :item="item" />
          </div>
        </section>
      </div>
      <!--EplNewStatementEmpty /-->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import StatementItem from "./StatementItem/index";
import EplNewStatementEmpty from "../components/EplNewStatementEmpty";
export default {
  name: "EplStatement",
  data() {
    return {};
  },
  components: { StatementItem, EplNewStatementEmpty },
  computed: {
    ...mapGetters(["loggedIn", "filteredStatement"])
  },
  mounted() {
    this.$store.dispatch("filterStatement", this.$route.params.statementType);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EplNewStatement.vue